import moment from "moment";

moment().locale("pt-br");

moment.updateLocale("pt-br", {
    months: [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
    ],
    monthsShort: [
        "jan",
        "fev",
        "mar",
        "abr",
        "mai",
        "jun",
        "jul",
        "ago",
        "set",
        "out",
        "nov",
        "dez",
    ],
    weekdays: [
        "Domingo",
        "Segunda",
        "Terça",
        "Quarta",
        "Quinta",
        "Sexta",
        "Sábado",
    ],
    weekdaysShort:[
        "dom",
        "seg",
        "ter",
        "qua",
        "qui",
        "sex",
        "sáb",
    ],
    longDateFormat: {
        LT: "HH:mm",
        LLLL: "dddd, D [de] MMMM [de] YYYY, HH:mm",
    },
});

export const formatDate = (date) => {
    return moment(date).format("LLLL");
};

export const formatPrice = (price) => {
    while (price.length < 3) {
        price = `0${price}`;
    }
    return "R$ " + price.slice(0, price.length - 2) + "," + price.slice(-2);
};
